import React from "react";
import CustomConfirmationDialog from "../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog";
import { withSnackbar } from "notistack";
import { postData } from "../../../../../api/componentAPIs";

const DeleteDriverPreference = (props) => {
  // Deleting driverPreference from the table

  const deleteDriverPreference = () => {
    const data = {
      scenarioId: props.userData.userProfile.scenarioID,
      terminalId: props.userData.userProfile.terminal.id,
      startTime: props.selectedDriverPreference.startTime,
    };
    postData("DeleteGroupedDriverPreferences", data).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          props.onCancel();
          props.enqueueSnackbar(`${data.startTime} deleted successfully`, {
            variant: "success",
          });
          props.getDriverPreferenceData();
          return;
        }
        handleError(data.startTime, response.status);
      },
      () => {
        handleError(data.startTime);
      }
    );
  };

  const handleError = (startTime, statusCode) => {
    if (statusCode === 403) {
      return;
    }
    props.enqueueSnackbar(`Failed to delete ${startTime}`, {
      variant: "error",
    });
  }

  return (
    <>
      {props.selectedDriverPreference && (
        <CustomConfirmationDialog
          title="Delete Driver Preference"
          cancelButtonLabel="Cancel"
          confirmButtonLabel="Delete"
          mode="danger"
          onConfirm={deleteDriverPreference}
          onCancel={props.onCancel}
        >
          Are you sure you want to delete selected driver preference from list?
        </CustomConfirmationDialog>
      )}
    </>
  );
};

export default withSnackbar(DeleteDriverPreference);
